// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button, Card, Heading, Text, Box } from '@chakra-ui/react';

const TotalScore = ({ scoreDisplay, onReset }) => {
  const [totalScore, setTotalScore] = useState(() => {
    // Initialize the state with the value from localStorage
    const storedTotalScore = localStorage.getItem('totalScore');
    return storedTotalScore ? parseInt(storedTotalScore, 10) : 0;
  });

  useEffect(() => {
    if (typeof scoreDisplay === 'number' && !isNaN(scoreDisplay)) {
      // Calculate the new total score by adding the current scoreDisplay
      const newTotalScore = totalScore + scoreDisplay;
      setTotalScore(newTotalScore);
      localStorage.setItem('totalScore', newTotalScore.toString());
    }
  }, [scoreDisplay]);

  const handleReset = () => {
    setTotalScore(0);
    localStorage.setItem('totalScore', '0');
    if (onReset) onReset();
  };

  return (
  <div>
      <Heading as="h5" size="xs" color="blue.500">
      <Text fontSize="13px" color="blue.500" fontWeight="normal" >Points: {totalScore} {/* Margin bottom to space from button */}
      <Button 
  onClick={handleReset} 
  colorScheme="red" 
  
  borderColor='red'
  borderRadius="50px" 
  
  fontSize="5px" 
  _hover={{ bg: 'blue.600' }} 
  _active={{ bg: 'blue.700' }} 
  _focus={{ boxShadow: 'outline' }}
>
  Reset Points
</Button></Text> 

      </Heading>
      </div>
  );
};

export default TotalScore;
